import { Commercial } from "./commercials.model";
import { Customer } from "./customers.model";

export class PointInterest {

    idPointInterest: number;
    name: string;
    address: string;
    ray: number;
    zoomLevel: number;
    imageUri: string;
    plyColor: string;
    coordinate: { lat: number, lng: number };
    type: 'MARKER' | 'POLYGON' | 'LINE' | number;
    decode: any[];
    hash: string;
    commercials: Commercial[] = [];
    customers: Customer[] = [];

    constructor() {
        this.ray = 10;
        this.decode = [];
        this.plyColor = "blue";
    }

}